import React from 'react';

interface StickyControlsProps {
  searchAndFiltersComponent: React.ReactNode;
}

interface DashboardLayoutProps {
  stickyControls: StickyControlsProps;
  kpiMetricsContent: React.ReactNode;
  healthScoreContent: React.ReactNode;
  mapContent: React.ReactNode;
  recommendationsContent: React.ReactNode;
}

export const StickyControls: React.FC<StickyControlsProps> = ({
  searchAndFiltersComponent,
}) => {
  return (
    <div className="sticky bg-white border-b border-gray-200 z-40 shadow-sm">
      <div className="bg-white px-6 py-3 border-b border-gray-200">
        {searchAndFiltersComponent}
      </div>
    </div>
  );
};

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  stickyControls,
  kpiMetricsContent,
  healthScoreContent,
  mapContent,
  recommendationsContent,
}) => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <StickyControls {...stickyControls} />

      {/* KPI Metrics Row */}
      {kpiMetricsContent}

      <div className="flex-1 p-2">
        {/* Main Dashboard Grid */}
        <div className="space-y-6">
          {/* Single Row: Health Score + Map + Recommendations (3 equal columns) */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-2">
            {/* Health Score - 1/3 */}
            <div className="lg:col-span-1">
              {healthScoreContent}
            </div>

            {/* Map - 1/3 */}
            <div className="lg:col-span-1">
              {mapContent}
            </div>

            {/* Recommendations - 1/3 */}
            <div className="lg:col-span-1">
              {recommendationsContent}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};